// extracted by mini-css-extract-plugin
module.exports = {"NavItem":"NavigationItem_NavItem__3wNHz","active":"NavigationItem_active__39N3a"};